import React from "react";

const VisionMission = () => {
  return (
    <section className="vision-mission-section section-padding">
      <div className="container">

        {/* Section Title */}
        <div className="section-title text-center mb-5">
          <span className="wow fadeInUp">Royal Route Cab</span>

          <h2 className="wow fadeInUp" data-wow-delay=".3s">
            Our Vision & Mission
          </h2>

          <p className="wow fadeInUp mt-3" data-wow-delay=".5s">
            Committed to delivering safe, reliable, and comfortable travel experiences for every journey.
          </p>
        </div>

        <div className="row g-4">

          {/* Vision */}
          <div className="col-lg-6 col-md-6">
            <div className="vision-card">

              <div className="vision-icon text-center">🚖</div>

              <h3 className="text-center">Our Vision</h3>

              <p>
                Our vision is to become a leading and most trusted cab service provider,
                recognized for delivering safe, comfortable, and reliable travel experiences.
                We aim to connect cities and people through seamless transportation services
                that prioritize customer satisfaction, safety, and convenience at every step.
              </p>

            </div>
          </div>

          {/* Mission */}
          <div className="col-lg-6 col-md-6">
            <div className="mission-card">

              <div className="mission-icon text-center">🎯</div>

              <h3 className="text-center">Our Mission</h3>

              <p>
                Our mission is to provide affordable, punctual, and high-quality cab services
                with professional drivers and well-maintained vehicles. We strive to make every
                ride smooth and stress-free by ensuring transparency, 24x7 availability, and
                customer-first service across all travel needs including local, outstation,
                and corporate travel.
              </p>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VisionMission;